import { CLOCK_PASS_QR_PREVIEW } from './clockPassHelpers';

export const createClockPassViewStyles = ({ ui: { colors, radius, space, touch, type } }) => ({
	actionSelector: {
		flexDirection: 'row',
		gap: space.xs,
		padding: space.xs,
		borderRadius: radius.card,
		backgroundColor: colors.card,
	},
	actionOption: {
		flex: 1,
		minHeight: touch.min,
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: radius.pill,
	},
	actionOptionSelected: {
		backgroundColor: colors.primary,
	},
	actionOptionText: {
		...type.bodySmallStrong,
		color: colors.textSecondary,
	},
	actionOptionTextSelected: {
		color: colors.onPrimary,
	},
	actionOptionTextDisabled: {
		color: colors.disabledText,
	},
	pressed: {
		opacity: 0.85,
	},
	qrCard: {
		alignItems: 'center',
		gap: space.xs,
		paddingVertical: space.xl,
		paddingHorizontal: space.lg,
		borderRadius: radius.hero,
		backgroundColor: colors.card,
	},
	qrTapTarget: {
		padding: space.lg,
		borderRadius: radius.hero,
		backgroundColor: colors.qrBackground,
		marginBottom: space.md,
	},
	qrPlaceholder: {
		minHeight: 236,
		alignItems: 'center',
		justifyContent: 'center',
	},
	qrPlaceholderText: {
		...type.bodySmall,
		color: colors.textSecondary,
		textAlign: 'center',
	},
	codeStatusText: {
		...type.rowTitleSemibold,
		color: colors.text,
		textAlign: 'center',
	},
	qrTapHint: {
		...type.secondary,
		color: colors.textSecondary,
		textAlign: 'center',
	},
	scanStatusCard: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.md,
		minHeight: touch.row,
		paddingHorizontal: space.lg,
		paddingVertical: space.md,
		borderRadius: radius.hero,
		backgroundColor: colors.card,
	},
	clockOutWarningText: {
		...type.bodySmall,
		color: colors.warning,
	},
	scanStatusLabel: {
		...type.secondary,
		color: colors.textSecondary,
	},
	scanFeedbackText: {
		...type.bodySmallSemibold,
		color: colors.success,
		flexShrink: 1,
		textAlign: 'right',
	},
	scanFeedbackEmpty: {
		color: colors.textSecondary,
	},
	errorText: {
		...type.secondary,
		color: colors.danger,
		textAlign: 'center',
	},
	qrPreviewModalRoot: {
		flex: 1,
		backgroundColor: colors.canvas,
		alignItems: 'center',
		justifyContent: 'center',
		paddingHorizontal: 22,
		paddingVertical: space.xl,
	},
	qrPreviewCloseButton: {
		position: 'absolute',
		right: CLOCK_PASS_QR_PREVIEW.CLOSE_BUTTON_RIGHT_OFFSET,
		minHeight: touch.min,
		justifyContent: 'center',
		paddingHorizontal: space.lg,
		borderRadius: radius.pill,
		backgroundColor: colors.raised,
		zIndex: 2,
		elevation: 2,
	},
	qrPreviewCloseButtonText: {
		...type.bodySmallStrong,
		color: colors.text,
	},
	qrPreviewBody: {
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	qrPreviewFrame: {
		borderRadius: radius.sheet,
		backgroundColor: colors.qrBackground,
		padding: space.lg,
		alignItems: 'center',
		justifyContent: 'center',
	},
	qrPreviewActionText: {
		...type.cardTitle,
		marginTop: space.gutter,
		color: colors.text,
		textAlign: 'center',
	},
	shiftSummaryModalRoot: {
		flex: 1,
		backgroundColor: colors.overlay,
		paddingHorizontal: 22,
		alignItems: 'center',
		justifyContent: 'center',
	},
	shiftSummaryCard: {
		width: '100%',
		maxWidth: 380,
		gap: space.md,
		borderRadius: radius.hero,
		padding: space.gutter,
		backgroundColor: colors.surface,
	},
	shiftSummaryTitle: {
		...type.title,
		color: colors.text,
	},
	shiftSummaryDurationCard: {
		gap: space.xs,
		borderRadius: radius.card,
		paddingVertical: space.md,
		paddingHorizontal: 14,
		backgroundColor: colors.card,
	},
	shiftSummaryDurationLabel: {
		...type.label,
		color: colors.textSecondary,
	},
	shiftSummaryDurationValue: {
		...type.hero,
		color: colors.success,
	},
	shiftSummaryRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.sm,
	},
	shiftSummaryRowLabel: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	shiftSummaryRowValue: {
		...type.bodySmallSemibold,
		color: colors.text,
	},
	shiftSummaryHint: {
		...type.caption,
		color: colors.textSecondary,
	},
});
